<template>
    <PageHeader wide>
        <CategoryLogo v-if="rootCategory" :category="rootCategory" size="md" />
        <div>
            <CategoryBreadcrumbs :categories="category?.Parents ?? []" />
            <h1 v-if="category?.Manufacturer" class="flex gap-2 my-2">
                <NuxtLink :to="localePath('/part-category/' + category.Path)">
                    {{ category.Name }}
                </NuxtLink>
                <i class="fass fa-chevron-right"></i>
                <span>{{ category.Manufacturer.Name }}</span>
            </h1>
            <h1 v-else class="my-2">{{ category?.Name }}</h1>
        </div>
    </PageHeader>
</template>
<script setup lang="ts">
const localePath = useLangPath();
const { category } = injectCategory();

const rootCategory = computed<Category | null>(() => {
    const parents = category.value?.Parents;
    if (Array.isArray(parents) && parents.length > 0) return parents[0] ?? null;
    return category.value ?? null;
});
</script>
